import Collapse from "@mui/material/Collapse";
import { useGeneralData } from "modules/moduleTemplates/components/ModuleDetailsDrawer/stores/useGeneralData";
import React, { type ChangeEvent, type FC } from "react";
import TextField from "shared/components/Form/TextField";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  COLOR_BLACK,
  COLOR_GREY_11,
  COLOR_SECONDARY_LIGHT,
} from "shared/theme/colors";
import { AddIcon } from "shared/theme/icons/AddIcon";
import { DeleteIcon } from "shared/theme/icons/DeleteIcon";
import {
  StyledContainer,
  StyledIconButton,
  StyledTransitionGroup,
} from "./styled";
import { TEXT_BLOCK_DESCRIPTION_LIMIT } from "entities/modules/constants";

const TextBlockForm: FC = () => {
  const { contentBlocks, setContentBlocks } = useGeneralData();

  if (!contentBlocks) {
    return null;
  }

  const onChangeTitle = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => {
    const newContent = contentBlocks.map((item, i) =>
      index === i ? { ...item, title: e.target.value } : item,
    );

    setContentBlocks(newContent);
  };

  const onChangeDescription = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => {
    const newContent = contentBlocks.map((item, i) =>
      index === i ? { ...item, description: e.target.value } : item,
    );

    setContentBlocks(newContent);
  };

  const onRemoveItem = (index: number) => {
    const newItems = [
      ...contentBlocks.slice(0, index),
      ...contentBlocks.slice(index + 1),
    ];
    setContentBlocks(newItems);
  };

  return (
    <>
      <StyledTransitionGroup>
        {contentBlocks.map((item, index) => (
          <Collapse key={index}>
            <StyledContainer>
              <TextField
                id={`title-${index}`}
                label="Title*"
                placeholder="Click here to edit text"
                fullWidth
                required
                value={contentBlocks[index].title}
                onChange={(e) => onChangeTitle(e, index)}
                labelColor={COLOR_BLACK}
              />
              <TextField
                id={`description-${index}`}
                label="Body Copy*"
                placeholder="Click here to edit text"
                fullWidth
                required
                multiline
                value={contentBlocks[index].description}
                onChange={(e) => onChangeDescription(e, index)}
                charactersLimit={TEXT_BLOCK_DESCRIPTION_LIMIT}
                InputProps={{ minRows: 5 }}
                labelColor={COLOR_BLACK}
              />
              {contentBlocks.length > 1 && (
                <StyledIconButton onClick={() => onRemoveItem(index)} data-testid="delete-block">
                  <DeleteIcon size={24} color={COLOR_SECONDARY_LIGHT} />
                </StyledIconButton>
              )}
            </StyledContainer>
          </Collapse>
        ))}
      </StyledTransitionGroup>
      <PrimaryButton
        color="secondary"
        variant="outlined"
        title="Add New"
        icon={<AddIcon color={COLOR_GREY_11} />}
        onClick={() => {
          setContentBlocks([...contentBlocks, { title: "", description: "" }]);
        }}
      />
    </>
  );
};

export default TextBlockForm;
